import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { get as _get } from 'lodash';

import { faqQuestion as trackFaqQuestion } from 'analytics/faq';
import { updateAccordion } from 'actions';

import Accordion from 'components/Accordion/Accordion';
import localize from 'components/Localize/Localize';

import styles from './FaqsContainer.css';
import translations from './translations';

class FaqsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.toggleAccordion = this.toggleAccordion.bind(this);
  }

  toggleAccordion(accordion, key, show, title) {
    this.props.updateAccordion(accordion, key, show);
    if (show) {
      trackFaqQuestion(this.props.analytics.category, title);
    }
  }

  renderFAQ(item, key) {
    return (
      <div
        className={styles[`faq-group`]}
        key={key}
      >
        <div className={styles[`faq-group-inner`]}>
          <h2 className={styles[`faq-group-heading`]}>{item.title}</h2>
          <div
            className={styles[`faq-group-content`]}
            dangerouslySetInnerHTML={{__html: item.content}}
          />
        </div>
      </div>
    );
  }

  renderFAQContent() {
    if (this.props.noCollapse) {
      return this.props.t[this.props.contentKey].items.map(this.renderFAQ);
    }

    return (
      <Accordion
        contentKey={this.props.contentKey}
        items={this.props.t[this.props.contentKey].items}
        itemsVisibility={this.props.itemsVisibility}
        toggle={this.toggleAccordion}
      />
    );
  }

  render() {
    return (
      <section className={styles[`container`]}>
        <h2 className={styles[`heading`]}>{this.props.t[this.props.contentKey].heading}</h2>
        {this.renderFAQContent()}
        <a
          className={styles[`cta`]}
          href={this.props.t[this.props.contentKey].ctaLink}
          role="button"
        >
          {this.props.t[this.props.contentKey].cta}
        </a>
      </section>
    );
  }
}

FaqsContainer.propTypes = {
  analytics: PropTypes.shape({
    category: PropTypes.string,
  }),
  contentKey: PropTypes.string.isRequired,
  itemsVisibility: PropTypes.object,
  noCollapse: PropTypes.bool,
  t: PropTypes.objectOf(PropTypes.shape({
    heading: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    ctaLink: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
  })),
};

FaqsContainer.defaultProps = {
  noCollapse: false,
};

const mapStateToProps = (state, props) => ({
  itemsVisibility: _get(state, `accordions.${props.contentKey}`),
  analytics: {
    category: _get(state, `product.productCategory`),
  },
});

const mapDispatchToProps = (dispatch) => ({
  updateAccordion: (accordion, key, show) => {
    dispatch(updateAccordion(accordion, key, show));
  },
});

export const NonLocalizedFaqsContainer = connect(mapStateToProps, mapDispatchToProps)(FaqsContainer);

export default localize(NonLocalizedFaqsContainer, translations);
